import React, { PureComponent } from 'react';
import Loadable from 'react-loadable';

const LoadBook = Loadable({
    loader: () => import('./index.jsx'),
    loading() {
        return <div>Loading...</div>;
    },
});

export default class Book extends PureComponent {
    render() {
        return (
            <div style={{ position: 'relative' }}>
                <LoadBook {...this.props} />
            </div>
        );
    }
}
